// extracted by mini-css-extract-plugin
export default {"title":"sidebar_title__mSBiL","features":"sidebar_features__4mCQE"};